import { render, staticRenderFns } from "./NotificationInformation.vue?vue&type=template&id=7daffb32&"
import script from "./NotificationInformation.vue?vue&type=script&lang=js&"
export * from "./NotificationInformation.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInformation.vue?vue&type=style&index=0&id=7daffb32&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7daffb32')) {
      api.createRecord('7daffb32', component.options)
    } else {
      api.reload('7daffb32', component.options)
    }
    module.hot.accept("./NotificationInformation.vue?vue&type=template&id=7daffb32&", function () {
      api.rerender('7daffb32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/NotificationInformation.vue"
export default component.exports